import { Injectable, Renderer, ElementRef } from '@angular/core';

@Injectable()
export class HelpTextService {
  constructor() {}

  changeMessage(message: string, referControl: HTMLElement = null) {
    setTimeout(() => {
      const containerHelper = document.querySelector('.help-text-container p');
      containerHelper.innerHTML = message;
      if (referControl) {
        const positionTop = document.querySelector('.container-fluid.h-100.mb-50').scrollTop;
        const top = referControl.getBoundingClientRect().top - 255 + positionTop;
        const container = <HTMLElement>(document.querySelector('.help-text-container'));
        container.style.top = top + 'px';
      }
    }, 500);
  }
}
